/* Load More for the homepage product grid: reveals hidden cards in place.
   On mobile, cards hidden only on mobile (--desktop-only) are revealed first, --reveal-mobile at a time.
   Once all hidden cards are shown, the button turns into a "View all" link. */
(function () {
  const mobile = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('[data-load-more]').forEach((button) => {
    const grid = button.closest('.product-grid').querySelector('[data-product-grid]');
    if (!grid) return;

    const pending = () => [
      ...(mobile.matches ? grid.querySelectorAll('.product-grid__item--desktop-only') : []),
      ...grid.querySelectorAll('[data-extra][hidden]'),
    ];

    button.addEventListener('click', () => {
      const step =
        parseInt(grid.style.getPropertyValue(mobile.matches ? '--reveal-mobile' : '--reveal'), 10) || 8;

      pending()
        .slice(0, step)
        .forEach((item) => {
          item.removeAttribute('hidden');
          item.classList.remove('product-grid__item--hidden', 'product-grid__item--desktop-only');
        });

      if (pending().length === 0) {
        const link = document.createElement('a');
        link.className = button.className.replace('product-grid__load-more', 'product-grid__view-all');
        link.href = button.dataset.viewAllUrl;
        link.textContent = button.dataset.viewAllLabel || 'View all';
        button.replaceWith(link);
      }
    });
  });
})();
